var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawalHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.9702V13.0302C22 13.5802 21.56 14.0302 21 14.0502H19.04C17.96 14.0502 16.97 13.2602 16.88 12.1802C16.82 11.5502 17.06 10.9602 17.48 10.5502C17.85 10.1702 18.36 9.9502 18.92 9.9502H21C21.56 9.9702 22 10.4202 22 10.9702Z",
    fill: "url(#paint0_linear_6242_71436)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.47 15.55H19.04C17.14 15.55 15.54 14.12 15.38 12.3C15.29 11.26 15.67 10.22 16.43 9.48C17.07 8.82 17.96 8.45 18.92 8.45H20.47C20.76 8.45 21 8.21 20.97 7.92C20.75 5.49 19.14 3.83 16.75 3.55C16.51 3.51 16.26 3.5 16 3.5H7C6.72 3.5 6.45 3.52 6.19 3.56C3.64 3.88 2 5.78 2 8.5V15.5C2 18.26 4.24 20.5 7 20.5H16C18.8 20.5 20.73 18.75 20.97 16.08C21 15.79 20.76 15.55 20.47 15.55ZM13 9.75H7C6.59 9.75 6.25 9.41 6.25 9C6.25 8.59 6.59 8.25 7 8.25H13C13.41 8.25 13.75 8.59 13.75 9C13.75 9.41 13.41 9.75 13 9.75Z",
    fill: "url(#paint1_linear_6242_71436)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96888 20.3766L8.97021 20.3754C9.90257 19.5554 10.5 18.351 10.5 17C10.5 14.5139 8.48614 12.5 6 12.5C4.94122 12.5 3.96265 12.872 3.18877 13.4887C2.15248 14.3112 1.5 15.5838 1.5 17C1.5 19.4861 3.51386 21.5 6 21.5C7.13858 21.5 8.17371 21.071 8.96888 20.3766ZM6.38564 17.4595L6.38563 17.4595L6.38275 17.4613L5.13275 18.2113L5.12255 18.2174L5.11265 18.224C5.09427 18.2362 5.05765 18.25 5 18.25C4.91917 18.25 4.83581 18.2068 4.78947 18.1338C4.71538 18.002 4.76289 17.8555 4.87194 17.7919L4.87195 17.7919L4.87583 17.7896L5.76583 17.2596L6.01 17.1142V16.83V15.75H6.01015L6.00985 15.7378C6.00688 15.6159 6.11365 15.5 6.25 15.5C6.38386 15.5 6.5 15.6161 6.5 15.75V17.25C6.5 17.3383 6.44901 17.4221 6.38564 17.4595Z",
    fill: "url(#paint2_linear_6242_71436)",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6242_71436",
    x1: 19.4354,
    y1: 9.9502,
    x2: 19.4354,
    y2: 14.0502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6242_71436",
    x1: 11.4863,
    y1: 3.5,
    x2: 11.4863,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6242_71436",
    x1: 6,
    y1: 13,
    x2: 6,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalHistory);
export default __webpack_public_path__ + "static/media/withdrawalHistory.e050b0d153e9f662a99305a98a44b9d2.svg";
export { ForwardRef as ReactComponent };